export class RecordBase {
    shown!:boolean;
}